import React from "react";
import Cards from "common-ui-components/components/overview-cards/Cards";

const formatCount = (value, loading) =>
  loading ? "--" : value == null ? "--" : Number(value).toLocaleString();

const PatchSummaryCards = ({ overview, loading = false }) => {
  const totalPatches = Number(overview?.totalPatches) || 0;
  const totalInstalled = Number(overview?.totalInstalledPatches) || 0;
  const compliance = totalPatches
    ? `${((totalInstalled / totalPatches) * 100).toFixed(1)}%`
    : overview
      ? "0%"
      : "--";

  return (
    <Cards
      loading={loading}
      cards={[
        {
          title: "Missing Patches",
          value: formatCount(overview?.totalMissingPatches, loading),
          color: "#2e5bdc",
        },
        {
          title: "Affected Devices",
          value: formatCount(overview?.totalDevicesWithMissingPatches, loading),
          color: "#0891b2",
        },
        {
          title: "Critical Patches",
          value: formatCount(overview?.totalMissingCriticalPatches, loading),
          color: "#dc2626",
        },
        {
          title: "Reboot Required",
          value: formatCount(overview?.totalPatchesRebootRequired, loading),
          color: "#d97706",
        },
        {
          title: "Awaiting Approval",
          value: formatCount(overview?.awaitingApprovalPatches, loading),
          color: "#8b5cf6",
        },
        // {
        //   title: "Patch Compliance",
        //   value: loading ? "--" : compliance,
        //   color: "#059669",
        // },
      ]}
    />
  );
};

export default PatchSummaryCards;
